import { TypeaheadService } from '../../typeahead/typeahead.service'
import * as $ from 'jquery';
import { UrlUtility } from '../../utility/url'

export class ProductsSearchCommon {

    public static init() {
        TypeaheadService.setupTypeaheadRemote('input#findProduct', '/ajaxProductSearchSuggestions?q=%QUERY',
            'products', 'name', false,
            result => console.log(result), null,
            data => {
                let query = $('input#findProduct').val();
                let start = data.name.toLowerCase().indexOf(query.toString().toLowerCase());
                if (start > -1)
                    return `<div class="product-select-option"><a href="${data.url}">${data.name.substr(0, start) + '<strong>' + data.name.substr(start, query.toString().length) + '</strong>' + data.name.substr(start + query.toString().length)}</a></div>`;
                return `<div class="product-select-option"><a href="${data.url}">${data.name}</a></div>`
            }, 'No matching products');
        $(document).off('click', '.search-container.products .search-button');
        $(document).on('click', '.search-container.products .search-button', ProductsSearchCommon.openResults);
        $(document).off('click', '.search-container.products .search-button');
        $(document).on('click', '.search-container.products .search-button', ProductsSearchCommon.openResults);
        $(document).off('keydown', '.search-container.products input#findProduct');
        $(document).on('keydown', '.search-container.products input#findProduct', ev => {
            if (ev.keyCode == 13)
                ProductsSearchCommon.openResults(ev);
        });


    }

    private static openResults(ev) {
        let query = $(ev.target).closest('.search-container').find('input#findProduct').val();

        let url = $('#findProduct').attr('data-result-url');

        console.log(url);

        if (query) {
            location.href = url + `?q=${query}`;
        }
    }
}